import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageContext, LanguageProvider } from './contexts/LanguageContext';
import GlobalStyles from './styles/GlobalStyles';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import SubscriptionTerms from './pages/SubscriptionTerms';
import RefundPolicy from './pages/RefundPolicy';
import GooglePlayComingSoon from './pages/GooglePlayComingSoon';
import AppStoreComingSoon from './pages/AppStoreComingSoon';
import PricingPage from './pages/Pricing';
import styled from 'styled-components';

// Компонент загрузки
const LoadingScreen = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  background-color: #131313;
  color: #fff;
  font-size: 1.5rem;
  
  .logo {
    font-size: 2.5rem;
    font-weight: 700;
    
    .one {
      color: #fff;
    }
    
    .cal {
      color: #34D399;
    }
    
    .ai {
      color: #fff;
    }
  }
`;

// Обертка для приложения
const AppContent = () => {
  const { isLoading } = useContext(LanguageContext);
  
  if (isLoading) {
    return (
      <LoadingScreen>
        <div className="logo">
          <span className="one">1</span>
          <span className="cal">cal</span>
          <span className="ai">.ai</span>
        </div>
      </LoadingScreen>
    );
  }
  
  return (
    <Router>
      <GlobalStyles />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/subscription" element={<SubscriptionTerms />} />
          <Route path="/refund" element={<RefundPolicy />} />
          <Route path="/google-play" element={<GooglePlayComingSoon />} />
          <Route path="/app-store" element={<AppStoreComingSoon />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/features" element={<Home />} />
          <Route path="/how-it-works" element={<Home />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
};

const App = () => {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
};

export default App; 